<div style="text-align: center; max-width: 630px">
  <div mat-dialog-content>
    <lemon-dialog-header> Aloita uusi sopimuskausi </lemon-dialog-header>

    <p style="text-align: left">Sopimuskausi pitää merkitä alkavaksi päivämäärällä, jolloin asiakas ensimmäisen kerran aikoo käyttää Lemonaidia.</p>
    <p style="text-align: left">Uusi sopimuskausi merkitään alkavaksi {{ sopimuskausiLomake.alkaa().value() | ldate | async }}.</p>

    <div>
      <mat-form-field style="max-width: 200px; margin-left: 10px; margin-right: 10px; margin-bottom: 22px; margin-top: 44px">
        <mat-label>Alkaa</mat-label>
        <input #sopimuskausiFormGroupAlkaaInputti type="text" [min]="minimiAlkaaPaivamaara" [matDatepicker]="pickerAlkaa" [formField]="sopimuskausiLomake.alkaa" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="pickerAlkaa"></mat-datepicker-toggle>
        @if (naytetaankoVirhe(sopimuskausiLomake.alkaa, 'required')) {
          <mat-error> Alkamispäivä puuttuu </mat-error>
        }
        @if (naytetaankoVirhe(sopimuskausiLomake.alkaa, 'edellinen')) {
          <mat-error> Uusi sopimuskausi ei voi alkaa samaan aikaan tai ennen edellisen loppumista. </mat-error>
        }
        @if (naytetaankoVirhe(sopimuskausiLomake.alkaa, 'min')) {
          <mat-error> Uusi sopimuskausi ei voi alkaa samaan aikaan tai ennen edellisen loppumista. </mat-error>
        }
        @if (naytetaankoVirhe(sopimuskausiLomake.alkaa, 'matDatepickerMin')) {
          <mat-error> Uusi sopimuskausi ei voi alkaa samaan aikaan tai ennen edellisen loppumista. </mat-error>
        }
        <mat-datepicker #pickerAlkaa></mat-datepicker>
      </mat-form-field>
    </div>

    <div style="text-align: left; padding: 0 20px">
      <app-sopimusversio [lomake]="sopimusversioLomake" [hideVoimassaAlkaen]="true"></app-sopimusversio>
    </div>
  </div>
  <div mat-dialog-actions style="padding-left: 0; padding-right: 0">
    <app-secondary-button mat-dialog-close actionId="Uusi sopimuskausi: Peruuta ja sulje dialog">Peruuta</app-secondary-button>
    <app-primary-button (click)="tallenna()" actionId="Uusi sopimuskausi, tallenna tiedot" [actionContext]="[sopimuskausiLomake().value()]">Tallenna</app-primary-button>
  </div>
</div>
